import { error } from "jquery";
import {ErrorObject} from "../../error/ErrorObject";
import error_objectHtml from './error-object.html?raw';

export let template: string = error_objectHtml;

export class viewModel {
    constructor(private errorObject: ErrorObject) {
    }

}